/**
 * Broadcast Redux Slice
 * Manages broadcast state from WebSocket updates
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  urgentBroadcasts: [],
  connected: false,
  lastUpdated: null,
};

const broadcastSlice = createSlice({
  name: 'broadcasts',
  initialState,
  reducers: {
    setBroadcasts: (state, action) => {
      state.items = action.payload;
      state.urgentBroadcasts = action.payload.filter(
        (b) => b.priority === 'urgent' && b.show_as_banner
      );
      state.lastUpdated = new Date().toISOString();
    },

    addBroadcast: (state, action) => {
      state.items.unshift(action.payload);

      if (action.payload.priority === 'urgent' && action.payload.show_as_banner) {
        state.urgentBroadcasts.unshift(action.payload);
      }

      state.lastUpdated = new Date().toISOString();
    },

    updateBroadcast: (state, action) => {
      const index = state.items.findIndex((b) => b.id === action.payload.id);

      if (index !== -1) {
        state.items[index] = action.payload;

        const urgentIndex = state.urgentBroadcasts.findIndex((b) => b.id === action.payload.id);
        if (urgentIndex !== -1) {
          state.urgentBroadcasts[urgentIndex] = action.payload;
        }

        state.lastUpdated = new Date().toISOString();
      }
    },

    setConnected: (state, action) => {
      state.connected = action.payload;
    },

    clearBroadcasts: (state) => {
      state.items = [];
      state.urgentBroadcasts = [];
      state.connected = false;
      state.lastUpdated = null;
    },
  },
});

export const { setBroadcasts, addBroadcast, updateBroadcast, setConnected, clearBroadcasts } =
  broadcastSlice.actions;

// Selectors
export const selectBroadcasts = (state) => state.broadcasts.items;
export const selectUrgentBroadcasts = (state) => state.broadcasts.urgentBroadcasts;
export const selectBroadcastConnected = (state) => state.broadcasts.connected;

// Filtered selectors
export const selectActiveBroadcasts = (state) => state.broadcasts.items.filter((b) => b.is_active);

export const selectBroadcastsByPriority = (priority) => (state) =>
  state.broadcasts.items.filter((b) => b.priority === priority);

export default broadcastSlice.reducer;
